module.exports = __webpack_public_path__ + "img/cy-one.0e1cdf96.png";